/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateBorrowerRealEstateAddressDto } from './CreateBorrowerRealEstateAddressDto';
import {
    CreateBorrowerRealEstateAddressDtoFromJSON,
    CreateBorrowerRealEstateAddressDtoFromJSONTyped,
    CreateBorrowerRealEstateAddressDtoToJSON,
    CreateBorrowerRealEstateAddressDtoToJSONTyped,
} from './CreateBorrowerRealEstateAddressDto';
import type { PropertyTypeEnum } from './PropertyTypeEnum';
import {
    PropertyTypeEnumFromJSON,
    PropertyTypeEnumFromJSONTyped,
    PropertyTypeEnumToJSON,
    PropertyTypeEnumToJSONTyped,
} from './PropertyTypeEnum';

/**
 * Simplified command to update a borrower real estate property.
 * Only address is required. Area, roomCount and propertyType are optional.
 * 
 * @export
 * @interface UpdateBorrowerRealEstateCommand
 */
export interface UpdateBorrowerRealEstateCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateBorrowerRealEstateCommand
     */
    area?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateBorrowerRealEstateCommand
     */
    roomCount?: number | null;
    /**
     * 
     * @type {PropertyTypeEnum}
     * @memberof UpdateBorrowerRealEstateCommand
     */
    propertyType?: PropertyTypeEnum;
    /**
     * 
     * @type {CreateBorrowerRealEstateAddressDto}
     * @memberof UpdateBorrowerRealEstateCommand
     */
    address: CreateBorrowerRealEstateAddressDto;
}



/**
 * Check if a given object implements the UpdateBorrowerRealEstateCommand interface.
 */
export function instanceOfUpdateBorrowerRealEstateCommand(value: object): value is UpdateBorrowerRealEstateCommand {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function UpdateBorrowerRealEstateCommandFromJSON(json: any): UpdateBorrowerRealEstateCommand {
    return UpdateBorrowerRealEstateCommandFromJSONTyped(json, false);
}

export function UpdateBorrowerRealEstateCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBorrowerRealEstateCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'area': json['area'] == null ? undefined : json['area'],
        'roomCount': json['roomCount'] == null ? undefined : json['roomCount'],
        'propertyType': json['propertyType'] == null ? undefined : PropertyTypeEnumFromJSON(json['propertyType']),
        'address': CreateBorrowerRealEstateAddressDtoFromJSON(json['address']),
    };
}

export function UpdateBorrowerRealEstateCommandToJSON(json: any): UpdateBorrowerRealEstateCommand {
    return UpdateBorrowerRealEstateCommandToJSONTyped(json, false);
}

export function UpdateBorrowerRealEstateCommandToJSONTyped(value?: UpdateBorrowerRealEstateCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'area': value['area'],
        'roomCount': value['roomCount'],
        'propertyType': PropertyTypeEnumToJSON(value['propertyType']),
        'address': CreateBorrowerRealEstateAddressDtoToJSON(value['address']),
    };
}

